import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { TableContainer } from "@mui/material";
import { useOverlayScrollbar } from "./useOverlayScrollbar";
import "./CustomScrollTable.sass";

const DEFAULT_MAX_HEIGHT = 250;

export const CustomScrollTable = ({
  children,
  className = "",
  containerClassName = "",
  maxHeight = DEFAULT_MAX_HEIGHT,
  isTable = true,
  scrollable = true,
}) => {
  const {
    viewportRef,
    trackRef,
    trackHRef,
    contentRef,
    thumb,
    thumbH,
    showTrack,
    showTrackH,
    dragging,
    onTrackPointerDown,
    onTrackHPointerDown,
    onMouseEnter,
    onMouseLeave,
  } = useOverlayScrollbar();

  const containerStyle = isTable
    ? { height: maxHeight, minHeight: maxHeight, maxHeight }
    : { maxHeight };

  const viewportStyle = isTable
    ? {
        height: "100%",
        maxHeight: "100%",
        overflowY: scrollable ? "auto" : "hidden",
      }
    : { maxHeight };

  return (
    <div
      className={classnames(
        "custom-scroll-container",
        {
          "custom-scroll-container--box": !isTable,
          "custom-scroll-container--lock-y": !scrollable,
          "custom-scroll-container--dragging": dragging,
        },
        containerClassName,
      )}
      style={containerStyle}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div
        ref={viewportRef}
        className="custom-scroll-container__viewport"
        style={viewportStyle}
      >
        <div ref={contentRef} className="custom-scroll-container__content">
          {isTable ? (
            <TableContainer
              className={className}
              sx={{ maxHeight: "none", overflow: "visible" }}
            >
              {children}
            </TableContainer>
          ) : (
            <div className={`custom-scroll-container__list ${className}`}>
              {children}
            </div>
          )}
        </div>
      </div>

      <div
        ref={trackRef}
        className={classnames("custom-scroll-container__track", {
          "custom-scroll-container__track--visible": showTrack,
        })}
        aria-hidden="true"
        onPointerDown={onTrackPointerDown}
      >
        <div
          className="custom-scroll-container__thumb"
          style={{
            height: thumb.height,
            transform: `translateY(${thumb.top}px)`,
          }}
        />
      </div>

      {isTable && (
        <div
          ref={trackHRef}
          className={classnames("custom-scroll-container__track-h", {
            "custom-scroll-container__track-h--visible": showTrackH,
          })}
          aria-hidden="true"
          onPointerDown={onTrackHPointerDown}
        >
          <div
            className="custom-scroll-container__thumb-h"
            style={{
              width: thumbH.width,
              transform: `translateX(${thumbH.left}px)`,
            }}
          />
        </div>
      )}
    </div>
  );
};

CustomScrollTable.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  maxHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isTable: PropTypes.bool,
  scrollable: PropTypes.bool,
};

export default CustomScrollTable;
